// src/pages/VividhaHome.jsx
import React, { useState } from "react";
import { useNavigate, Link } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import { logout } from "../../redux/actions/authActions";

const VividhaHome = () => {
  const authState = useSelector((state) => state.authReducer || {});
  const isLoggedIn = authState?.isLoggedIn || false;
  const userName = authState?.user?.name || "User";

  const navigate = useNavigate();
  const dispatch = useDispatch();

  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const [activeTab, setActiveTab] = useState("Governance");

  const handleLogout = () => {
    dispatch(logout());
    navigate("/vividha");
  };

  // Main tabs
  const groupNames = [
    { label: "Governance", emoji: "🏛️" },
    { label: "Ranking & Rewards", emoji: "🤝" },
    { label: "Vendor Marketplace", emoji: "🏪" },
    { label: "Society Transport", emoji: "🚍" },
    { label: "Event Management", emoji: "🎉" },
    { label: "AI & Smart Automation", emoji: "🤖" },
    { label: "Privacy & Consent", emoji: "🔒" },
    { label: "Worker & Staff", emoji: "👩‍🔧" },
    { label: "Sustainability & Blue", emoji: "🌱" },
    { label: "Analytics & Benchmarking", emoji: "📊" },
  ];

  // Buttons inside each tab
  const menuButtons = [
    // Governance
    { label: "Committee Dashboard", emoji: "📊", link: "/gov-dashboard", group: "Governance" },
    { label: "Voting", emoji: "🗳️", link: "/voting-agm", group: "Governance" },
    { label: "Minutes of Meeting", emoji: "📝", link: "/tasks/add", group: "Governance" },
    { label: "Conflict Alerts", emoji: "⚠️", link: "/conflict-alerts", group: "Governance" },
    { label: "Approval Workflows", emoji: "✔️", link: "/approval-workflows", group: "Governance" },
    { label: "Root Cause Analysis", emoji: "🧩", link: "/fivewhys-analysis-home", group: "Governance" },
    { label: "VIVIDHA Smart Presentation", emoji: "📊", link: "/visualbrief-home", group: "Governance" },
    { label: "VIVIDHA POV Forum", emoji: "🗣️", link: "/povify-home", group: "Governance" },
    { label: "Tasks & More", emoji: "📔", link: "/gov-daily", group: "Governance" },
    { label: "Daily Journal", emoji: "📔", link: "/myjournal-home", group: "Governance" },
    { label: "Goal Board", emoji: "🎯", link: "/sheearns-goalboard", group: "Governance" },
    { label: "Kanban", emoji: "📊", link: "/sheearns-kanban", group: "Governance" },

    // Ranking & Rewards
    { label: "Owners Excellence Index (OEI)", emoji: "🏆", link: "/leaderboard", group: "Ranking & Rewards" },
    { label: "Committee Effectiveness Index (CEI)", emoji: "📈", link: "/cei-score", group: "Ranking & Rewards" },
    { label: "Tenant Excellence Index(TEI)", emoji: "🏘️", link: "/tbs-score", group: "Ranking & Rewards" },
    { label: "All Resident Excellence Index (AREI)", emoji: "🧩", link: "/rcs-score", group: "Ranking & Rewards" },
    { label: "Vendor Reliability Score", emoji: "⭐", link: "/vrs-score", group: "Ranking & Rewards" },
    { label: "Sustainability Index (SI)", emoji: "🏅", link: "/blue-score", group: "Ranking & Rewards" },
    { label: "Society Operational Index (SOI)", emoji: "🏠", link: "/analytics-sos", group: "Ranking & Rewards" },
    { label: "Micro-Grants & Rewards", emoji: "💵", link: "/microgrants", group: "Ranking & Rewards" },
    { label: "Badges & Spotlight", emoji: "🌟", link: "/badges-spotlight", group: "Ranking & Rewards" },
    { label: "Explainable Rankings", emoji: "🔍", link: "/ai-ranking-explain", group: "Ranking & Rewards" },

    // Vendor Marketplace
    { label: "Vendor Marketplace", emoji: "💼", link: "/vendor-marketplace", group: "Vendor Marketplace" },    
    { label: "Vendor Onboarding", emoji: "✔️", link: "/vendor-onboarding", group: "Vendor Marketplace" },
    { label: "Work History", emoji: "📁", link: "/vendor-history", group: "Vendor Marketplace" },
    { label: "SLA Templates", emoji: "📑", link: "/sla-templates", group: "Vendor Marketplace" },
    { label: "Escrow Payments", emoji: "💳", link: "/escrow-payments", group: "Vendor Marketplace" },
    { label: "Dispute Resolution", emoji: "⚖️", link: "/vendor-disputes", group: "Vendor Marketplace" },
    { label: "Vendor & Maintenance Metrics", emoji: "🏗️", link: "/analytics-vendor", group: "Vendor Marketplace" },
    { label: "Digital Twin", emoji: "🏬👀", link: "/twiworld", group: "Vendor Marketplace" },

    // Event Management
    { label: "Plan & Budget", emoji: "🗂️", link: "/event-plan-budget", group: "Event Management" },
    { label: "Book Facilities", emoji: "🏢", link: "/event-booking", group: "Event Management" },
    { label: "Volunteer Management", emoji: "🙋‍♀️", link: "/event-volunteers", group: "Event Management" },
    { label: "Ticketing & Payments", emoji: "💰", link: "/event-ticketing", group: "Event Management" },
    { label: "Pre-Event Compliance", emoji: "✅", link: "/pre-event-checklist", group: "Event Management" },
    { label: "On-Site Dashboard", emoji: "🖥️", link: "/event-onsite", group: "Event Management" },
    { label: "Post-Event Analytics", emoji: "📊", link: "/event-postanalytics", group: "Event Management" },
    { label: "P&L Report", emoji: "💹", link: "/event-pl-report", group: "Event Management" },

    // AI & Smart Automation
    { label: "Complaint Triage", emoji: "📨", link: "/ai-complaint-triage", group: "AI & Smart Automation" },
    { label: "Predictive Maintenance", emoji: "🛠️", link: "/ai-predictive-maintenance", group: "AI & Smart Automation" },
    { label: "Utility Anomaly Detection", emoji: "⚡💧", link: "/ai-utility-anomaly", group: "AI & Smart Automation" },
    { label: "Smart Calendar & Minutes", emoji: "🗓️", link: "/ai-smart-calendar", group: "AI & Smart Automation" },
    { label: "Smart Vendor Matching", emoji: "📌", link: "/ai-vendor-matching", group: "AI & Smart Automation" },

    // Privacy & Consent
    { label: "Visitor Data Management", emoji: "👥", link: "/privacy-visitor-data", group: "Privacy & Consent" },
    { label: "Resident Data Export", emoji: "📁", link: "/privacy-data-export", group: "Privacy & Consent" },
    { label: "Per-Field Consent", emoji: "✅", link: "/privacy-consent", group: "Privacy & Consent" },
    { label: "Audit Trail & Logs", emoji: "🗂️", link: "/privacy-audit", group: "Privacy & Consent" },

    // Worker & Staff
    { label: "Staff Profiles", emoji: "👷‍♀️", link: "/staff-profiles", group: "Worker & Staff" },
    { label: "Shift Scheduling", emoji: "🕒", link: "/staff-schedule", group: "Worker & Staff" },
    { label: "Attendance", emoji: "💼", link: "/staff-payroll", group: "Worker & Staff" },
    { label: "Grievances & Feedback", emoji: "🗣️", link: "/staff-grievances", group: "Worker & Staff" },
    { label: "Anonymized Records", emoji: "👀", link: "/staff-anon-records", group: "Worker & Staff" },

    // Sustainability & Blue
    { label: "Water & Energy Dashboard", emoji: "💧⚡", link: "/blue-utilities", group: "Sustainability & Blue" },
    { label: "Waste & Recycling", emoji: "♻️", link: "/blue-waste", group: "Sustainability & Blue" },
    { label: "Blue Badge Incentives", emoji: "🌿", link: "/blue-badges", group: "Sustainability & Blue" },
    { label: "Digital Writing Paper", emoji: "✍️📄", link: "/sheearns-touchbookplain", group: "Sustainability & Blue" },
    { label: "Digital Writing Grid", emoji: "✍️📊", link: "/sheearns-touchbookgrid", group: "Sustainability & Blue" },

    // Analytics & Benchmarking
    { label: "KPI Comparison", emoji: "🔍", link: "/analytics-kpi", group: "Analytics & Benchmarking" },
    { label: "Trend Analysis & Reports", emoji: "📈", link: "/analytics-trends", group: "Analytics & Benchmarking" },

    // Society Transport
    { label: "Vehicle Registry", emoji: "🚌", link: "/transport-vehicles", group: "Society Transport" },
    { label: "Routes & Scheduling", emoji: "🛣️", link: "/transport-routes", group: "Society Transport" },
    { label: "Booking & Boarding", emoji: "🎫", link: "/transport-booking", group: "Society Transport" },
    { label: "Utilization Analytics", emoji: "📊", link: "/transport-analytics", group: "Society Transport" },
  ];

  const filteredButtons = menuButtons.filter((btn) => btn.group === activeTab);

  return (
    <div className="min-h-screen flex flex-col bg-black text-blue-200 font-sans">
      {/* Header */}
      <header className="sticky top-0 z-50 bg-[#0a2a0d] border-b border-blue-700 px-4 py-2 flex items-center justify-between shadow-lg">
        <div className="flex flex-col">
          <div className="text-xl lg:text-2xl font-bold text-blue-400">🌀 VIVIDHA</div>
          <div className="text-[10px] lg:text-[12px] text-yellow-200">
            Voices In Vibrant Inclusive Decisions for Harmonious Action
          </div>
          <div className="text-[10px] lg:text-[12px] text-blue-200">
            Smart Community, Society & Federation Governance 
          </div>
        </div>

        {/* Desktop user controls */}
        <div className="hidden md:flex items-center gap-3">
          {isLoggedIn ? (
            <>
              <div className="text-xs text-left text-blue-300">{userName}</div>
              <button
                onClick={handleLogout}
                className="p-2 mt-2 rounded-md bg-red-600 hover:bg-red-700 transition"
                title="Logout"
              >
                ⏻
              </button>
            </>
          ) : (
            <>
              <button
                onClick={() => navigate("/login")}
                className="px-3 py-1 rounded-full border border-blue-700 text-sm text-blue-200 hover:bg-blue-900"
              >
                Login
              </button>
              <button
                onClick={() => navigate("/signup")}
                className="px-3 py-1 rounded-full bg-blue-500 text-white text-sm hover:bg-blue-400"
              >
                Register
              </button>
            </>
          )}
        </div>

        {/* Mobile hamburger */}
        <button
          onClick={() => setIsMobileMenuOpen((s) => !s)}
          className="md:hidden w-6 h-6 flex items-center justify-center text-xl text-blue-300 bg-blue-500"
          aria-label="Toggle menu"
        >
          {isMobileMenuOpen ? "×" : "☰"}
        </button>
      </header>

      {/* Mobile menu */}
      {isMobileMenuOpen && (
        <div className="md:hidden bg-[#0a2a0d] border-b border-blue-700 px-4 py-2 animate-fadeIn">
          {isLoggedIn ? (
            <div className="flex flex-row items-center justify-center gap-3">
              <span className="text-blue-300 font-medium whitespace-nowrap h-7">
                Welcome, {userName}
              </span>
              <button
                onClick={handleLogout}
                className="rounded-md bg-red-600 hover:bg-red-700 w-7 h-7 flex items-center justify-center text-white"
                title="Logout"
              >
                ⏻
              </button>
            </div>
          ) : (
            <div className="flex flex-row items-center justify-center gap-6">
              <Link to="/login" className="text-blue-300 hover:text-yellow-300">Login</Link>
              <span className="text-blue-500">|</span>
              <Link to="/signup" className="text-blue-300 hover:text-yellow-300">Register</Link>
            </div>
          )}
        </div>
      )}

      <div className="bg-cyan-800 text-white text-xs sm:text-sm py-2">
        <div className="max-w-6xl mx-auto px-3 flex flex-wrap justify-center gap-4">
          <a href="/msme-whysakshammsme" className="hover:text-yellow-200">💭 About VIVIDHA</a>
          <a href="/ledger" className="hover:text-yellow-200">📊 Free Society ERP</a>
          <a href="/msme-think5whysfaq" className="hover:text-yellow-200">🤔 FAQ</a>
          <a href="/agenticsim" className="hover:text-yellow-200">🤖 Ask AI</a>
        </div>
      </div>
      
      {/* Tabs */}
      <div className="mt-1 mb-1 px-3 py-2 border-b border-blue-700">
        <div className="grid grid-cols-3 sm:grid-cols-3 md:grid-cols-5 gap-0 place-items-center">
          {groupNames.map((group) => (
            <button
              key={group.label}
              onClick={() => setActiveTab(group.label)}
              className={`flex flex-col items-center justify-center w-full px-2 py-2 rounded-md text-xs sm:text-sm font-medium transition ${
                activeTab === group.label
                  ? "bg-blue-700 text-yellow-200 shadow-md"
                  : "bg-blue-900 text-blue-100 hover:bg-blue-800"
              }`}
            >
              <span className="text-xl">{group.emoji}</span>
              <span className="mt-1 text-m text-center">{group.label}</span>
            </button>
          ))}
        </div>
      </div>

      {/* Main grid */}
      <main className="flex-grow mx-auto px-3 py-2 w-full justify-center items-center text-center">
        <div className="grid grid-cols-3 sm:grid-cols-3 md:grid-cols-5 gap-0 place-items-center">
          {filteredButtons.length === 0 ? (
            <div className="col-span-3 sm:col-span-3 md:col-span-5 text-center text-blue-400">
              No items in this category.
            </div>
          ) : (
            filteredButtons.map((btn, idx) => (
              <button
                key={`${btn.label}-${idx}`}
                onClick={() => navigate(btn.link)}
                className="flex flex-col items-center justify-center w-full px-1.5 py-1 rounded-md text-[14px] sm:text-m font-medium transition bg-transparent hover:bg-blue-700 hover:text-yellow-200 text-blue-100 break-words text-center shadow-sm"
                title={btn.label}
              >
                <span className="text-xl lg:text-lg">{btn.emoji}</span>
                <span className="mt-1">{btn.label}</span>
              </button>
            ))
          )}
        </div>
      </main>

      {/* Footer */}
      <footer className="bg-[#0a2a0d] border-t border-blue-700 text-blue-300 py-4">
        <div className="max-w-6xl mx-auto px-3 flex flex-col md:flex-row items-center justify-between gap-3">
          <div className="text-xs lg:text-sm">
            © 2025 Think5Whys Global DeepTech Solutions. All rights reserved.
          </div>
          <div className="flex flex-wrap gap-4 text-xs lg:text-sm">
            <Link to="/about-us" className="text-white hover:text-blue-400">About</Link>
            <Link to="/privacy-policy" className="text-white hover:text-blue-400">Privacy Policy</Link>
            <Link to="/terms-of-use" className="text-white hover:text-blue-400">Terms of Use</Link>
            <Link to="/contact-us" className="text-white hover:text-blue-400">Contact</Link>
          </div>
        </div>
      </footer>
    </div>
  );
};

export default VividhaHome;
